module.exports = __webpack_public_path__ + "img/alerts.b099d266.svg";